import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AiOutlineEdit, AiOutlineRight } from "react-icons/ai";
import { ImLifebuoy } from "react-icons/im";
import { FaClipboardList } from "react-icons/fa";
import { HiShieldExclamation } from "react-icons/hi";
import { Button } from "react-bootstrap";

import { Auth } from "services/action";

import { Page } from "ui/components";

import logo from "../../../assets/ic_launcher.png";

const ProfileScreen = () => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateAuth = useSelector((state) => state?.Auth);

  return (
    <Page hasFooter full title={`Akun`}>
      <div className="px-2 py-3">
        <div className="row align-items-center border-bottom pb-3 mb-2">
          <div className="col-3 text-center pe-0">
            <img
              src={logo}
              className="rounded-circle border border-2 border-white"
              alt=""
              style={{ height: 60, width: 60 }}
            />
          </div>
          <div className="col-9 ps-0 pe-3">
            <div className="d-flex flex-row align-items-center justify-content-between">
              <div className="px-2 text-secondary">
                <div>
                  <b>{StateAuth?.session?.name}</b>
                </div>
                <small>{StateAuth?.session?.phone}</small>
              </div>
              <div
                className="p-2 bg-primary-lt text-primary rounded-3 d-flex align-items-center justify-content-center"
                style={{ height: 42, width: 42 }}
                onClick={() => History.push("/profil/update")}
              >
                <AiOutlineEdit size={20} />
              </div>
            </div>
          </div>
        </div>

        <div className="px-2">
          <div
            className="row align-items-center mb-2"
            onClick={() => History.push("/help")}
          >
            <div className="col-2 text-center">
              <div
                className="p-2 bg-primary-lt text-primary rounded-3 d-flex align-items-center justify-content-center"
                style={{ height: 42, width: 42 }}
              >
                <ImLifebuoy size={20} />
              </div>
            </div>
            <div className="col-10 ps-0 ">
              <div className="d-flex flex-row align-items-center justify-content-between">
                <div className="px-2 text-secondary">
                  <div>Pusat Bantuan</div>
                </div>
                <div
                  className="p-2 text-secondary rounded-3 d-flex align-items-center justify-content-center"
                  style={{ height: 42, width: 42 }}
                >
                  <AiOutlineRight size={18} />
                </div>
              </div>
            </div>
          </div>

          <div
            className="row align-items-center mb-2"
            onClick={() => History.push("/terms")}
          >
            <div className="col-2 text-center">
              <div
                className="p-2 bg-primary-lt text-primary rounded-3 d-flex align-items-center justify-content-center"
                style={{ height: 42, width: 42 }}
              >
                <FaClipboardList size={20} />
              </div>
            </div>
            <div className="col-10 ps-0 ">
              <div className="d-flex flex-row align-items-center justify-content-between">
                <div className="px-2 text-secondary">
                  <div>Syarat &amp; Ketentuan</div>
                </div>
                <div
                  className="p-2 text-secondary rounded-3 d-flex align-items-center justify-content-center"
                  style={{ height: 42, width: 42 }}
                >
                  <AiOutlineRight size={18} />
                </div>
              </div>
            </div>
          </div>

          <div
            className="row align-items-center mb-2"
            onClick={() => History.push("/privacy")}
          >
            <div className="col-2 text-center">
              <div
                className="p-2 bg-primary-lt text-primary rounded-3 d-flex align-items-center justify-content-center"
                style={{ height: 42, width: 42 }}
              >
                <HiShieldExclamation size={20} />
              </div>
            </div>
            <div className="col-10 ps-0">
              <div className="d-flex flex-row align-items-center justify-content-between">
                <div className="px-2 text-secondary">
                  <div>Kebijakan Privasi</div>
                </div>
                <div
                  className="p-2 text-secondary rounded-3 d-flex align-items-center justify-content-center"
                  style={{ height: 42, width: 42 }}
                >
                  <AiOutlineRight size={18} />
                </div>
              </div>
            </div>
          </div>

          <Button
            type="button"
            variant="primary"
            className="pe-4 ps-4 rounded w-100 fs-7 mt-2"
            onClick={() => Dispatch(Auth.$logout())}
          >
            Keluar
          </Button>
        </div>
      </div>
    </Page>
  );
};

export default ProfileScreen;
